<i18n
  src="@/locales/views/agro_exporter/production/basic_container_export/show_process.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/exportation.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/container.yml" lang="yaml"></i18n>
<template>
  <div class="mt-6">
    <h1 class="page-title">
      <i class="fa-solid fa-ship"></i><span class="space-icon"></span>
      {{ $t("labels.exportations_title") }}
    </h1>

    <div class="flex flex-row justify-end">
      <div class="panel-plain-label">
        <badge-default :label="statsExportations.total + ' ' + $t('labels.total_number_exportations')" />
        <span class="space-actions" />
        <exportation-status :status_id="0" :prepend_label="' ' + statsExportations.by_status[0]" />
        <span class="space-actions" />
        <exportation-status :status_id="1" :prepend_label="' ' + statsExportations.by_status[1]" />
        <span class="space-actions" />
        <exportation-status :status_id="2" :prepend_label="' ' + statsExportations.by_status[2]" />
      </div>
      <div class="grow"></div>

      <button type="button" @click.prevent="downloadExportationsContainersRepXlsx" class="btn-white">
        <i :class="[
          'fa-solid',
          downloading_exportations_containers
            ? 'fa-sync fa-spin'
            : 'fa-file-excel'
        ]"></i><span class="space-icon"></span>{{ $t("labels.general_report_button") }}
      </button>
      <span class="space-actions" />
      <new-button @click.prevent="goToNewExportation()"
        :label="$t('labels.new_exportation_button')" />
    </div>

    <div class="mt-8 flex flex-col">
      <div class="table-first-container">
        <div class="table-second-container">
          <div class="table-third-container">
            <table class="table">
              <thead class="table-header">
                <tr>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.exportation.week") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.exportation.booking_code") }}
                  </th>
                  <th v-if="display_dam_column" scope="col" class="table-header-cell">
                    {{ $t("model.exportation.dam_code") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.exportation.exportation_type") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.exportation.status") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.exportation.departured_at") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.exportation.container") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.exportation.destination_export") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.container.customer") }}
                  </th>
                  <th scope="col" class="table-header-cell" v-if="agro_exporter_process.display_provider">
                    {{ $t("model.container.provider") }}
                  </th>
                  <th scope="col" class="table-header-cell"></th>
                </tr>
              </thead>
              <tbody class="table-body">
                <tr class="table-row" v-for="exportation in exportations" :key="exportation.id">
                  <td class="table-cell">
                    {{ exportation.week }}
                  </td>
                  <td class="table-cell-main link" @click.prevent="goToShowExportation(exportation.id)">
                    {{ exportation.booking_code }}
                  </td>
                  <td v-if="display_dam_column" class="table-cell">
                    {{ exportation.dam_code }}
                  </td>
                  <td class="table-cell">
                    <exportation-type :exportation_type_id="exportation.exportation_type_id" :only_icon="true" />
                  </td>
                  <td class="table-cell">
                    <exportation-status :status_id="exportation.status_id" />
                  </td>
                  <td class="table-cell">
                    {{ dateFormatterDayMonthName(exportation.departured_at) }}
                  </td>
                  <td class="table-cell">
                    <div class="link" v-for="container in exportation.containers" :key="container.id"
                      @click.prevent="goToShowContainer(container.id)">
                      {{ container.container_code }}
                      <span class="badge-danger" v-if="!container.container_code">
                        {{ $t("model.container.no_container_code") }} </span><br />{{ container.container_request_code }}
                    </div>
                  </td>

                  <td class="table-cell">
                    {{ exportation.destination_export.name }}
                  </td>
                  <td class="table-cell">
                    <div v-for="container in exportation.containers" :key="container.id">
                      {{ container.customer?.name }}
                    </div>
                  </td>
                  <td class="table-cell" v-if="agro_exporter_process.display_provider">
                    <div v-for="container in exportation.containers" :key="container.id">
                      {{ container.provider_names.join(' | ') }}
                    </div>
                  </td>
                  <td class="table-cell-action">
                    <exportation-details :exportation="exportation" icon="fa-solid fa-eye" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- v-if="load_total" -->
    <table-paginator v-model="current_page" :total_rows="statsExportations.total"
      :rows_per_page="rowsPerPage.exportations" />
  </div>
</template>

<script>
import ExportationStatus from "@/components/views/agro_exporter/production/shared/exportation/ExportationStatus.vue";
import ExportationType from "@/components/views/agro_exporter/production/shared/exportation/ExportationType.vue";
import ExportationDetails from "@/components/views/agro_exporter/production/shared/exportation/ExportationDetails.vue";
import TablePaginator from "@/components/views/layout/TablePaginator.vue";
import ShowProcessTabsMixin from "@/components/views/agro_exporter/production/basic_container_export/show_process/show_process_tabs_mixin.js";
import Requester from "@/views/agro_exporter/requesters/production/basic_container_export/show_process.js";

export default {
  name: "ShowProcessExportations",
  mixins: [ShowProcessTabsMixin],
  components: {
    ExportationStatus,
    ExportationType,
    ExportationDetails,
    TablePaginator,
  },
  props: {
    agro_exporter_process: {},
    exportations: {
      type: Array,
      required: true
    },
    currentPage: { type: Object, default: () => { return { exportations: 1 } } },
    rowsPerPage: { type: Object, default: () => { return { exportations: 12 } } },
    statsExportations: {
      tpye: Object,
      default: () => { return { total: 0, by_status: {} } }
    }
  },
  data() {
    return {
      current_page: this.currentPage.exportations,
      downloading_exportations_containers: false
    };
  },
  watch: {
    current_page: function (newValue) {
      let current_page = this.currentPage;
      current_page.exportations = newValue;
      this.$emit('update:currentPage', current_page)
    },
  },
  computed: {
    display_dam_column: function () {
      return this.exportations.some(
        exportation => exportation.dam_code != null
      );
    }
  },
  methods: {
    downloadExportationsContainersRepXlsx: async function () {
      this.downloading_exportations_containers = true;
      try {
        let response = await Requester.downloadExportationsContainersRepXlsx(
          this.agro_exporter_process_id
        );

        const file = response.data;
        this.downloadFile(file, "Reporte General.xlsx");
      } catch (error) {
        error;
      }
      this.downloading_exportations_containers = false;
    },
    goToNewExportation: function () {
      this.$router.push({
        name: "ae_production_basic_container_export_new_exportation_path",
        params: {
          agro_exporter_process_id: this.agro_exporter_process_id
        }
      });
    },
    goToShowExportation: function (exportation_id) {
      this.$router.push({
        name: "ae_production_basic_container_export_show_exportation_path",
        params: {
          agro_exporter_process_id: this.agro_exporter_process_id,
          exportation_id: exportation_id
        }
      });
    },
    goToShowContainer: function (container_id) {
      this.$router.push({
        name: "ae_production_basic_container_export_show_container_path",
        params: {
          agro_exporter_process_id: this.agro_exporter_process_id,
          container_id: container_id
        }
      });
    }
  }
};
</script>
